import { useTheme } from '@mui/system';
import { Typography, Box } from '@mui/material';
import { StyledLink, StyledPaper, PageTitle, SectionDivider, Paragraph } from 'components/layouts/SharedStyles';
import { CalendarLinks } from 'components/CalendarLinks';
import { config } from 'config';

export const Home = () => {
  const theme = useTheme();

  return (
    <StyledPaper extraStyles={{ maxWidth: 750, textAlign: 'center' }}>
      <PageTitle>
        {config.event.title}<br />
        {config.event.location}<br />
        {config.event.date}
      </PageTitle>

      <Box mt={-5} mb={4}>
        <img src={'/some_event/dancer.jpg'} alt='' style={{ width: "100%", height: "auto" }} />
      </Box>

      {config.registration.waitlistMode &&
        <Box sx={{ my: 4, p: 2, backgroundColor: theme.palette.background.sticky, display: 'flex', justifyContent: 'center', alignItems: 'center'  }}>
          <strong>{config.event.title} is full. Sign up for the waitlist below.</strong>
        </Box>
      }

      <Typography variant="h6" sx={{ mb: 2 }}>
        We are a zesty, high-energy dance weekend for experienced dancers.<br />
      </Typography>

      <Paragraph>
        Music by <StyledLink internal={true} to="/staff#band1">Notorious</StyledLink> and <StyledLink internal={true} to="/staff#band2">Playing with Fyre</StyledLink>
      </Paragraph>

      <Paragraph>
        Calling by <StyledLink internal={true} to="/staff#caller1">Seth Tepfer</StyledLink> and <StyledLink internal={true} to="/staff#caller2">Will Mentor</StyledLink><br />
        Role terms will be Larks and Robins.
      </Paragraph>

      <Paragraph>
        Registration: $120-240 sliding scale ($180 break-even)
      </Paragraph>

      <CalendarLinks />

      <SectionDivider />

      <Paragraph sx={{ mb: 2 }}>
        some_event will follow mask guidelines of the weekly Seattle contras.<br />
        As of November 1, well-fitting face masks are required.<br />
        Please do not attend if you are feeling unwell.<br />
        See <StyledLink internal={true} to='/about#covid'>here</StyledLink> for the full Covid policy.<br />
      </Paragraph>

      {config.registration.showWaiver &&
        <Paragraph>
          You will need to sign a <StyledLink to={'/supersonic/supersonic-waiver.pdf'}>waiver</StyledLink> electronically <em>as part of the registration process</em>.
        </Paragraph>
      }

      <Paragraph>
        some_event is a fragrance-free event. Please use only fragrance-free products.
      </Paragraph>

      <SectionDivider/>

      <Paragraph>
        We will be dancing primarily complex contras with limited or no walkthroughs.<br />
        Many participants easily dance both roles and role switching is common.
      </Paragraph>

      <Paragraph>
        some_event Contra Dance Weekend gives experienced dancers the opportunity to explore ways in which to challenge themselves and improve their skills as dance partners while experiencing complex dances and immense joy.
      </Paragraph>

      <Paragraph>
        We begin the weekend with no walkthrough contra corners. Are you comfortable navigating complex dances often with no walkthroughs or hash calls? Do you recover quickly from mistakes? If you answered yes, this weekend is for you.
      </Paragraph>

      <SectionDivider/>

      <Typography variant="h4" fontStyle="italic" gutterBottom>
      {/* <StyledLink internal={true} to="/registration">Registration open</StyledLink> */}
      Registration opening in the future!
      </Typography>
    </StyledPaper>
  );
};
